module.exports = __webpack_public_path__ + "media/images/home/mini/screen_4-7f6624b1f3d7e4a693f1bb95b53ca8c1.png";